import common from '../../common';

const _draw = Symbol('_draw');
const _stopAudio = Symbol('_stopAudio');

export default class Eraser {
	constructor() {
		// Constants.
		this.LINE_THICKNESS = 10;

		// Attributes.
		this._drawLayer = null;
		this._fillLayer = null;
		this._audio = null;
		this._arrCanvasContext = [];
	}

	init(drawLayer, fillLayer) {
		this._drawLayer = drawLayer;
		this._fillLayer = fillLayer;

		this._arrCanvasContext.push(this._drawLayer.context);
		this._arrCanvasContext.push(this._fillLayer._colourContext);
		this._arrCanvasContext.push(this._fillLayer._colourCodeContext);
	}
	onDrawBegan(point) {
		for (const context of this._arrCanvasContext) {
			context.save();
			context.globalCompositeOperation = 'destination-out';
			context.strokeStyle = 'rgba( 255, 255, 255, 255 )';

			this[_draw](context, point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
		}

		// TEST: DYN_OUT:
		const dynOutlineContext = common.game.canvas.drawLayer.dynOutlineContext;
		dynOutlineContext.save();
		dynOutlineContext.globalCompositeOperation = 'destination-out';
		dynOutlineContext.beginPath();
		dynOutlineContext.strokeStyle = 'rgba( 255, 255, 255, 255 )';
		dynOutlineContext.lineWidth = this.LINE_THICKNESS;
		dynOutlineContext.lineJoin = 'round';
		dynOutlineContext.moveTo(point.x, point.y);
		dynOutlineContext.lineTo(point.x + 0.1, point.y + 0.1);
		dynOutlineContext.closePath();
		dynOutlineContext.stroke();

		this._drawLayer.onContext_Changed();
		this._fillLayer.onContext_Changed();
	}

	onDrawMoved(from, to) {
		// Sfx.
		if (this._audio == null)
			this._audio = P3.audio.playSound('sfx_tool_eraser_loop_03', {'loop': true});

		P3.utils.delay(0.25, ()=> {
			this[_stopAudio]();
		}, null, this);

		this._lastPosition = common.renderer.plugins.interaction.mouse.global;

		for (const context of this._arrCanvasContext)
			this[_draw](context, from, to);

		this._drawLayer.onContext_Changed();
		this._fillLayer.onContext_Changed();

		// TEST: DYN_OUT:
		const dynOutlineContext = common.game.canvas.drawLayer.dynOutlineContext;
		dynOutlineContext.beginPath();
		dynOutlineContext.lineWidth = this.LINE_THICKNESS;
		dynOutlineContext.lineJoin = 'round';
		dynOutlineContext.moveTo(from.x, from.y);
		dynOutlineContext.lineTo(to.x, to.y);
		dynOutlineContext.closePath();
		dynOutlineContext.stroke();

		let stamps = common.gameScene.allStamps;
		for (const stamp of stamps) {
			let rect1 = {x: stamp.position.x, y: stamp.position.y, width: stamp.width, height: stamp.height};
			let rect2 = {x: to.x, y: to.y, width: 10, height: 10};
			if ((rect1.x - 325) < rect2.x + rect2.width &&
				(rect1.x - 325) + rect1.width > rect2.x &&
				rect1.y < rect2.y + rect2.height &&
				rect1.height + rect1.y > rect2.y){
				common.gameScene.gameLayer.removeChild(stamp);
				common.gameScene.allStamps.splice(common.gameScene.allStamps.indexOf(stamp), 1);
			}
		}
	}

	onDrawEnded() {
		// Sfx.
		if (this._audio != null)
			this[_stopAudio]();

		for (const context of this._arrCanvasContext)
			context.restore();

		// TEST: DYN_OUT:
		const dynOutlineContext = common.game.canvas.drawLayer.dynOutlineContext;
		dynOutlineContext.restore();
		common.game.canvas.drawLayer._dynOutlineLayerData = dynOutlineContext.getImageData(
			0,
			0,
			common.game.canvas.WIDTH,
			common.game.canvas.HEIGHT
		);

		this._fillLayer.updateContextData();
	}

	[_draw](context, from, to) {
		context.beginPath();
		context.lineWidth = this.LINE_THICKNESS;
		context.lineJoin = 'round';
		context.moveTo(from.x, from.y);
		context.lineTo(to.x, to.y);
		context.closePath();
		context.stroke();
	}

	[_stopAudio]() {
		this._audio && this._audio.stop();
		this._audio = null;
	}
}
